const picturesMockup = [
  {
    id: 0,
    link: "https://i.imgur.com/hBhcogl.jpg",
  },
];

export default picturesMockup;
